import { FC, useEffect, useRef } from 'react'

import SafetyCaseHazardFormFields from './safety-case-hazard-form-fields'

import { ISafetyCaseHazardFormProps } from './safety-case-hazard-form-types'

const SafetyCaseHazardForm: FC<ISafetyCaseHazardFormProps> = props => {
  const {
    handleSubmit,
    formName,
    submitting,
    values,
    setForm,
    form,
    valid,
    onChange,
    disabled = false,
    isViewMode,
  } = props

  const prevValuesRef = useRef(values)
  useEffect(() => {
    if (typeof onChange === 'function') {
      if (values !== prevValuesRef.current) {
        onChange(values, valid)
        prevValuesRef.current = values
      }
    }
  }, [onChange, valid, values])

  useEffect(() => {
    setForm && setForm(form)
    // eslint-disable-next-line
  }, [setForm])

  return (
    <form onSubmit={handleSubmit} id={formName}>
      <SafetyCaseHazardFormFields
        disabled={submitting || disabled}
        isViewMode={isViewMode}
        values={values}
      />
    </form>
  )
}

export default SafetyCaseHazardForm
